import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { UserApiV2 } from './types/User';
import { APIV2_URL } from './constants';

const getUser = (makeCall: MakeCall) => (userId: number | 'me' = 'me') =>
  makeCall<UserApiV2>('GET', `${APIV2_URL}/user/${userId}`);

export default getUser;
